/**
 * DASHBOARD ROUTES
 */
const routes = [
  {
    path: '/Blog',
    name: 'BlogViewComponent',
    component: 'Blog/BlogViewComponent'
  },
  {
    path: '/:slug',
    name: 'PostViewComponent',
    component: 'Blog/PostViewComponent'
  }
];

export default routes;
